abstract class BaseResultVM {
    sql: string;
    error: KnockoutObservable<string>;

    constructor(data) {
        this.sql = data?.sql;
        this.error = ko.observable(data?.error);
    }
}